import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Heart } from "lucide-react";

/**
 * Sticky bottom CTA visible only on mobile (lg:hidden).
 * - Shows "Create Profile" to unauthenticated visitors
 * - Hidden on auth pages and welcome page
 * - Hidden after scrolling past hero (gives breathing room)
 */
export default function MobileStickyCTA() {
    const { user, loading } = useAuth();
    const location = useLocation();
    const [show, setShow] = useState(true);

    useEffect(() => {
        const onScroll = () => {
            // Always show on mobile; only hide briefly near footer
            const nearFooter = window.innerHeight + window.scrollY > document.body.offsetHeight - 200;
            setShow(!nearFooter);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    // Hide on auth pages, dashboard, and when logged in (they have nav)
    const hiddenRoutes = ["/login", "/register", "/auth/callback", "/profile/setup"];
    if (hiddenRoutes.includes(location.pathname)) return null;
    if (loading) return null;
    if (user) return null; // logged-in users have full nav already
    if (!show) return null;

    return (
        <div className="lg:hidden fixed bottom-4 left-4 right-4 z-40 animate-fade-up">
            <Link
                to="/register"
                data-testid="mobile-sticky-cta"
                className="flex items-center justify-center gap-2 bg-gold text-navy font-sans text-sm font-semibold tracking-[0.12em] uppercase py-4 px-6 rounded-lg shadow-2xl shadow-gold/40 active:scale-[0.98] transition-transform"
                style={{ borderRadius: "8px" }}
            >
                <Heart className="h-4 w-4" strokeWidth={2.5} />
                Create Free Profile
            </Link>
        </div>
    );
}
